import { fetchFlask } from '../../utils/fetchFlask';

export const BI_GE_ACORDOS_API = 'getAcordos';
export const ACORDOS_STATUS_OPTIONS = ['CANCELADO', 'ATRASADO', 'RECEBIDO', 'A VENCER'];
export const ACORDOS_INITIAL_FILTERS = {
    status: ['ATRASADO', 'A VENCER'],
    razao_social: '',
    documento: ''
};
export const ACORDOS_DEBOUNCED_FILTER_FIELDS = ['razao_social', 'documento'];

export const buildAcordosPayload = ({ filters, page, pageSize }) => JSON.stringify({
    status: filters.status,
    razao_social: filters.razao_social,
    documento: filters.documento,
    page,
    page_size: pageSize
});

export const fetchAcordosPage = async ({ filters, page, pageSize }) => {
    const response = await fetchFlask(BI_GE_ACORDOS_API, buildAcordosPayload({
        filters,
        page,
        pageSize
    }));

    return response.data;
};

export const buildAcordosRows = (acordos) => acordos.map((acordo, index) => ({
    id: `${acordo.documento}-${acordo.vencimento}-${acordo.num_parcela}-${acordo.status}-${index}`,
    razao_social: acordo.razao_social,
    documento: acordo.documento,
    valor: Number(acordo.valor),
    num_parcela: acordo.num_parcela,
    vencimento: acordo.vencimento,
    status: acordo.status
}));
